<template>
  <div class="loading-spinner">
    <no-ssr placeholder="Loading..">
      <b-spinner label="Loading" :style="style" type="grow" variant="primary"/>
    </no-ssr>
  </div>
</template>

<script>
import { mapRoot } from '@src/mixins/root';

export default {
  props: {
    size: {
      type: String,
      default: () => '40px',
    },
  },
  computed: {
    ...mapRoot([ 'company' ]),
    style() {
      const { siteBranding: { primaryColour } = {} } = this.company || {};
      return {
        color: primaryColour || 'blue',
        height: this.size,
        width: this.size,
      };
    },
  },
};
</script>

<style lang="scss">
.loading-spinner {
  &.centered {
    text-align: center;
  }

  &.full-screen {
    display: flex;
    justify-content: center;

    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    top: 200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/misc/LoadingSpinner.vue